<template>
  <v-snackbar v-model="snackbar" :timeout="timeout" :color="type" bottom right>
    {{ message }}
    <v-btn dark icon @click="snackbar = false">
      <v-icon>mdi-close-circle</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: 'Notify',
    
  data: ()=> ({
    snackbar: false,
    timeout: 5000,
    message: '',
    type: '',
  }),

  methods: {
    notify(type, message){
      this.type = type;
      this.message = message;
      this.snackbar = true;
    }
  }
}
</script>